import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.scss']
})
export class RibbonComponent implements OnInit {
  AppConfig: any;

  constructor() { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/ui/ribbon/ribbon.component.ts